// extracted by mini-css-extract-plugin
export var aiStarSpin = "_rp-1";
export var spinner = "_rp-0";